import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Home } from './components/home/Home';
import { QR } from './components/qr/QR';

import './App.css';

function Page() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/qr" element={<QR />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <Suspense fallback={<div />}>
      <Page />
    </Suspense>
  );
}
